import isNumber from "lodash/isNumber";

import type { Record } from "~/tools/record";

export type ModalSize = "small" | "medium-small" | "medium-medium" | "medium" | "large";

const MODAL_WIDTH_BY_SIZE: Record<ModalSize, string> = {
	small: "520px",
	"medium-small": "750px",
	"medium-medium": "1000px",
	medium: "65vw",
	large: "85vw",
};

export const getModalWidth = (size: number | ModalSize): string =>
	isNumber(size) ? `${size}px` : MODAL_WIDTH_BY_SIZE[size];
